/** Where the audit action occurred (page path at write time). */
export function auditActionSource(): string {
  if (typeof window === "undefined") return "/";
  return window.location.pathname;
}
